export type OfferDefinitionDetailsTranslation = {
  actions: Record<'cancel' | 'save', string>;
  backAriaLabel: string;
  components: {
    actions: Record<
      'add' | 'addItemAriaLabel' | 'dragAriaLabel' | 'editAriaLabel' | 'expandAriaLabel',
      string
    >;
    dialog: {
      button: Record<'cancel' | 'save', string>;
      closeAriaLabel: string;
      form: Record<
        | 'basicInfo'
        | 'canBeDisabled'
        | 'canBeDisabledDescription'
        | 'containsPrices'
        | 'containsPricesDescription'
        | 'dictionaryType'
        | 'name'
        | 'validationStatus',
        string
      > & {
        items: {
          actions: string;
          add: string;
          description: string;
          dragAriaLabel: string;
          empty: string;
          emptyHint: string;
          infoNote: string;
          name: string;
          removeAriaLabel: string;
          title: string;
          type: string;
          typeAriaLabel: string;
        };
      };
      saveError: string;
      title: Record<'create' | 'edit', string>;
    };
    empty: string;
    itemCount: Record<'few' | 'many' | 'one', string>;
    title: string;
    valueType: Record<'DICTIONARY' | 'FILE' | 'TEXT', string>;
  };
  form: Record<
    'active' | 'activeHeader' | 'description' | 'name' | 'title' | 'workflowCode',
    string
  > & {
    valueType: Record<'DICTIONARY' | 'FILE' | 'TEXT', string>;
  };
  saveError: string;
  taskTemplates: {
    add: string;
    description: string;
    dragAriaLabel: string;
    empty: string;
    form: Record<
      | 'assignProcessSupervisor'
      | 'completionMode'
      | 'daysToDue'
      | 'daysToDueHelper'
      | 'description'
      | 'requiredStatus'
      | 'title',
      string
    >;
    removeAriaLabel: string;
    title: string;
  };
  title: Record<'create' | 'edit', string>;
};

export const offerDefinitionDetailsTranslation: OfferDefinitionDetailsTranslation = {
  actions: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  backAriaLabel: 'Wróć do listy definicji ofert',
  components: {
    actions: {
      add: 'Dodaj komponent',
      addItemAriaLabel: 'Dodaj pozycję komponentu',
      dragAriaLabel: 'Zmień kolejność komponentu',
      editAriaLabel: 'Edytuj komponent',
      expandAriaLabel: 'Rozwiń lub zwiń komponent',
    },
    dialog: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
      },
      closeAriaLabel: 'Zamknij dialog',
      form: {
        basicInfo: 'Podstawowe informacje',
        canBeDisabled: 'Możliwość wyłączenia komponentu',
        canBeDisabledDescription: 'Komponent można wyłączyć i nie będzie wyświetlany w ofercie.',
        containsPrices: 'Komponent zawiera ceny',
        containsPricesDescription: 'Pozycje mogą zawierać ceny, które będą widoczne w ofercie.',
        dictionaryType: 'Typ słownika',
        items: {
          actions: 'Akcje',
          add: 'Dodaj pozycję',
          description: 'Pozycje, które będą wypełniane w ofercie.',
          dragAriaLabel: 'Zmień kolejność pozycji',
          empty: 'Brak pozycji.',
          emptyHint: 'Dodaj pierwszą pozycję, która będzie dostępna podczas tworzenia oferty.',
          infoNote:
            'Kolejność pozycji zdefiniowana tutaj będzie domyślną kolejnością wyświetlania w ofercie.',
          name: 'Nazwa pozycji',
          removeAriaLabel: 'Usuń pozycję',
          title: 'Pozycje',
          type: 'Typ',
          typeAriaLabel: 'Typ pozycji',
        },
        name: 'Nazwa komponentu',
        validationStatus: 'Status walidacji',
      },
      saveError: 'Nie udało się zapisać komponentu.',
      title: {
        create: 'Dodaj komponent',
        edit: 'Edytuj komponent',
      },
    },
    empty: 'Brak komponentów',
    itemCount: {
      few: '{{count}} elementy',
      many: '{{count}} elementów',
      one: '{{count}} element',
    },
    title: 'Komponenty definicji',
    valueType: {
      DICTIONARY: 'Słownik',
      FILE: 'Plik',
      TEXT: 'Tekst',
    },
  },
  form: {
    active: 'Aktywny',
    activeHeader: 'Aktywna',
    description: 'Opis',
    name: 'Nazwa',
    title: 'Podstawowe informacje',
    valueType: {
      DICTIONARY: 'Słownik',
      FILE: 'Plik',
      TEXT: 'Tekst',
    },
    workflowCode: 'Kod workflow',
  },
  saveError: 'Nie udało się zapisać definicji oferty.',
  taskTemplates: {
    add: 'Dodaj szablon zadania',
    description:
      'Szablony zadań zapisują się razem z definicją przyciskiem „Zapisz”. Kolejność szablonów jest kolejnością zadań. Status wymagany wybierasz spośród statusów workflow.',
    dragAriaLabel: 'Zmień kolejność szablonu zadania',
    empty: 'Brak szablonów zadań',
    form: {
      assignProcessSupervisor: 'Przypisz opiekuna procesu',
      completionMode: 'Tryb zakończenia',
      daysToDue: 'Dni do terminu',
      daysToDueHelper: 'Liczone od utworzenia oferty',
      description: 'Opis',
      requiredStatus: 'Status wymagany',
      title: 'Tytuł',
    },
    removeAriaLabel: 'Usuń szablon zadania',
    title: 'Szablony zadań',
  },
  title: {
    create: 'Nowa definicja oferty',
    edit: 'Edycja definicji oferty',
  },
};
